import React, { useState, useEffect } from 'react';
import PromotionGroup from './PromotionGroup';

const SPREADSHEET_ID = '1aM34inYbqWJk_w0ALfhlLD6Ei4KCtsTggqVLsPPAa6g';
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const RANGE = 'Promociones!A:G';

const API_URL = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${RANGE}?key=${API_KEY}`;

const PromotionsView = () => {
  const [promotions, setPromotions] = useState([]);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error de la API de Google:", errorData);
          throw new Error('Error al obtener los datos de Google Sheets. Revisa la consola para más detalles.');
        }
        const data = await response.json();
        const values = data.values || [];
        
        const promotionsData = values.slice(1).map(row => ({
          tipo: row[0] || '',
          vigencia: row[1] || '',
          nombre: row[2] || '',
          descripcion: row[3] || '',
          canal: row[4] || '',
          condiciones: row[5] || '',
          url: row[6] || ''
        }));
        
        setPromotions(promotionsData);
        if (promotionsData.length > 0) {
          // Set the first channel as active by default
          const firstChannel = promotionsData.reduce((acc, p) => {
            if (p.canal && !acc) return p.canal;
            return acc;
          }, '');
          setActiveTab(firstChannel || (values[1] && values[1][4]) || 'General');
        }

      } catch (error) {
        setError(error.message);
        console.error("Error fetching data: ", error);
      }
    };

    fetchPromotions();
  }, []);

  const groupedPromotions = promotions.reduce((acc, promo) => {
    const channel = promo.canal || 'General';
    if (!acc[channel]) {
      acc[channel] = [];
    }
    acc[channel].push(promo);
    return acc;
  }, {});

  const channels = Object.keys(groupedPromotions);

  return (
    <>
      <div className="container">
        <nav className="tabs">
          {channels.map(channel => (
            <a 
              key={channel} 
              href={`#${channel}`}
              className={activeTab === channel ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab(channel);
              }}
            >
              {channel}
            </a>
          ))}
        </nav>

        {error && <p style={{color: 'red', textAlign: 'center'}}>{error}</p>}
      </div>

      <div className="tab-content">
        {activeTab && groupedPromotions[activeTab] ? (
          <PromotionGroup
            channel={activeTab}
            promotions={groupedPromotions[activeTab]}
          />
        ) : (
          !error && <p style={{textAlign: 'center'}}>Cargando promociones...</p>
        )}
      </div>
    </>
  );
};

export default PromotionsView;
